import * as React from "react";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { CustomerMergeModel } from "../../../../../../Wrap/Models/Models/Customer/CustomerMergeModel";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { CustomerMergeAction } from "../Action/CustomerMergeAction";
import { Addresses } from "./Addresses";
import { ContactInformation } from "./ContactInformation";
import { Declarations } from "./Declarations";
import { PersonalDetails } from "./PersonalDetails";
import { Regulatory } from "./Regulatory";
import { RegulatoryChecks } from "./RegulatoryChecks";
import { Roles } from "./Roles";
import { TickOrCorss } from "./TickOrCross";
import { UserGroup } from "./UserGroup";

interface ICustomerMergeDetailsProps {}

interface ICustomerMergeDetailsState {
    isLoading: boolean;
    data: CustomerMergeModel;
    customerSelected: Array<number>;
}

export class CustomerMergeDetails extends FormComponent<ICustomerMergeDetailsProps, ICustomerMergeDetailsState> {
    constructor(props: ICustomerMergeDetailsProps) {
        super(props);
        this.state = {
            isLoading: true,
            data: null,
            customerSelected: [],
        };
    }

    componentDidMount() {
        const customerId1 = getQueryParameters()["customerid1"];
        const customerId2 = getQueryParameters()["customerid2"];
        CustomerMergeAction.getCustomerMerge(customerId1, customerId2, (res) => {
            this.setState({ data: res, isLoading: false });
        });
    }

    public render(): JSX.Element {
        if (this.state.isLoading) {
            return (
                <div>
                    <h1 className="page-heading">Customer Merge</h1>
                    <PartLoading isLoading={true} />
                </div>
            );
        } else {
            return (
                <div>
                    <h1 className="page-heading">Customer Merge</h1>
                    <div className="row">
                        <div className="col-sm-5">
                            <h2>Customer 1</h2>
                        </div>
                        <div className="col-sm-2"></div>
                        <div className="col-sm-5">
                            <h2>Customer 2</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <PersonalDetails
                                pData={this.state.data.FirstCustomer.PersonalDetails}
                                eData={this.state.data.FirstCustomer.EmploymentDetails}
                                tData={this.state.data.FirstCustomer.CustomerTaxResidencyDetails}
                            />
                        </div>
                        <div className="col-sm-2">
                            <TickOrCorss type={"customer-details"} data={this.state.data} />
                        </div>
                        <div className="col-sm-5">
                            <PersonalDetails
                                pData={this.state.data.SecondCustomer.PersonalDetails}
                                eData={this.state.data.SecondCustomer.EmploymentDetails}
                                tData={this.state.data.SecondCustomer.CustomerTaxResidencyDetails}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-sm-5">
                            <ContactInformation
                                eData={this.state.data.FirstCustomer.EmailAddressDetails}
                                pData={this.state.data.FirstCustomer.PhoneNumberDetails}
                                otherpData={this.state.data.SecondCustomer.PhoneNumberDetails}
                            />
                        </div>
                        <div className="col-sm-2">
                            <TickOrCorss type={"contact-information"} data={this.state.data} />
                        </div>
                        <div className="col-sm-5">
                            <ContactInformation
                                eData={this.state.data.SecondCustomer.EmailAddressDetails}
                                pData={this.state.data.SecondCustomer.PhoneNumberDetails}
                                otherpData={this.state.data.FirstCustomer.PhoneNumberDetails}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <Addresses
                                aData={this.state.data.FirstCustomer.AddressDetails}
                                otheraData={this.state.data.SecondCustomer.AddressDetails}
                            />
                        </div>
                        <div className="col-sm-2">
                            <TickOrCorss type={"addresses"} data={this.state.data} />
                        </div>
                        <div className="col-sm-5">
                            <Addresses
                                aData={this.state.data.SecondCustomer.AddressDetails}
                                otheraData={this.state.data.FirstCustomer.AddressDetails}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <Regulatory
                                tData={this.state.data.FirstCustomer.CustomerTaxResidencyDetails}
                                othertData={this.state.data.SecondCustomer.CustomerTaxResidencyDetails}
                            />
                        </div>
                        <div className="col-sm-2">
                            <TickOrCorss type={"regulatory"} data={this.state.data} />
                        </div>
                        <div className="col-sm-5">
                            <Regulatory
                                tData={this.state.data.SecondCustomer.CustomerTaxResidencyDetails}
                                othertData={this.state.data.FirstCustomer.CustomerTaxResidencyDetails}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <RegulatoryChecks tData={this.state.data.FirstCustomer.RegulatoryCheck} />
                        </div>
                        <div className="col-sm-2">
                            <TickOrCorss type={"regulatory-checks"} data={this.state.data} />
                        </div>
                        <div className="col-sm-5">
                            <RegulatoryChecks tData={this.state.data.SecondCustomer.RegulatoryCheck} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <Roles
                                rData={this.state.data.FirstCustomer.AccountRoles}
                                otherrData={this.state.data.SecondCustomer.AccountRoles}
                            />
                        </div>
                        <div className="col-sm-2"></div>
                        <div className="col-sm-5">
                            <Roles
                                rData={this.state.data.SecondCustomer.AccountRoles}
                                otherrData={this.state.data.FirstCustomer.AccountRoles}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <UserGroup
                                gData={this.state.data.FirstCustomer.UserRoles}
                                othergData={this.state.data.SecondCustomer.UserRoles}
                            />
                        </div>
                        <div className="col-sm-2"></div>
                        <div className="col-sm-5">
                            <UserGroup
                                gData={this.state.data.SecondCustomer.UserRoles}
                                othergData={this.state.data.FirstCustomer.UserRoles}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-5">
                            <h3>Continue customer 1?</h3>
                            <CheckboxEditor
                                onChange={(v) => {
                                    const checked = this.state.customerSelected;
                                    if (v) {
                                        this.setState({ customerSelected: checked.concat(1) });
                                    } else {
                                        this.setState({ customerSelected: checked.filter((ele) => ele != 1) });
                                    }
                                }}
                                disabled={
                                    this.state.customerSelected.length !== 0 && this.state.customerSelected.includes(2)
                                }
                                value={this.state.customerSelected.includes(1)}
                            />
                        </div>
                        <div className="col-sm-2"></div>
                        <div className="col-sm-5">
                            <h3>Continue customer 2?</h3>
                            <CheckboxEditor
                                onChange={(v) => {
                                    const checked = this.state.customerSelected;
                                    if (v) {
                                        this.setState({ customerSelected: checked.concat(2) });
                                    } else {
                                        this.setState({ customerSelected: checked.filter((ele) => ele != 2) });
                                    }
                                }}
                                disabled={
                                    this.state.customerSelected.length !== 0 && this.state.customerSelected.includes(1)
                                }
                                value={this.state.customerSelected.includes(2)}
                            />
                        </div>
                    </div>
                    <hr />
                    {this.state.customerSelected.length > 0 && (
                        <Declarations data={this.state.data} customerSelected={this.state.customerSelected} />
                    )}
                </div>
            );
        }
    }
}
